const { lazy } = require("react");
module.exports = lazy;